var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _vm._v(" "),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaMarcas",
        attrs: {
          filterStatus: _vm.filterStatus,
          createButton: _vm.createButton,
          editButton: false,
          deleteButton: false,
          path: _vm.url + "/marcas/search",
          columns: [
            {
              display: "Código",
              value: "codigo"
            },
            {
              display: "Nombre",
              value: "nombre"
            },
            {
              display: "Descripción",
              value: "descripcion"
            },
            {
              display: "Fecha de creación",
              value: "created_at"
            },
            {
              display: "Fecha de modificación",
              value: "updated_at"
            }
          ]
        },
        on: { crear: _vm.crear, seleccionar: _vm.seleccionar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "marca"
          }
        },
        [
          _c("marca", {
            attrs: { searchButton: _vm.searchButton },
            on: { created: _vm.createdMarca }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Marcas")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43c9877c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c9877c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/marcas/ListaMarcas.vue
// module id = 535
// module chunks = 0